/** Stable empty set for optional highlight props — avoids new Set() per render. */
export const EMPTY_STRING_SET: ReadonlySet<string> = new Set()
